const escapeHtml = (text = '') =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const addInlinePlaceholders = block =>
  block.replace(/\*([^*\n]+)\*/g, '[[ITALIC::$1]]');

// Signature-domain linkify: the visible text stays the bare domain (the
// plain-text part is untouched), but the HTML href carries UTM params so
// outreach clicks classify as Email in GA4 instead of vanishing into Direct
// (2026-07-29 audit). Runs post-escape; the domain contains no escapable chars.
// No style attr: default blue/underline matches how Gmail was already
// auto-linking the bare domain, so recipients see zero visual change.
const SITE_LINK =
  '<a href="https://freshlybakedstudios.com/?utm_source=outreach&amp;utm_medium=email">' +
  'freshlybakedstudios.com</a>';
const linkifySignatureDomain = html =>
  html.replace(/(^|[\s>(])freshlybakedstudios\.com(?=$|[\s<).,])/g, `$1${SITE_LINK}`);

// Owner's usual signature includes his IG handle (2026-07-29). Same treatment:
// visible text stays "@alexanderalmgren", href carries the profile URL. UTM
// params ride along per owner request — note Instagram ignores them (we can't
// measure IG profile visits), they're only meaningful on our own domains.
const IG_LINK =
  '<a href="https://www.instagram.com/alexanderalmgren/?utm_source=outreach&amp;utm_medium=email">' +
  '@alexanderalmgren</a>';
const linkifySignatureInstagram = html =>
  html.replace(/(^|[\s>])@alexanderalmgren(?=$|[\s<.,])/g, `$1${IG_LINK}`);

export const textToHtml = (text = '') => {
  if (!text) return '';

  const body = text
    .trimEnd()
    .split(/\n{2,}/)
    .map(block => {
      const withPlaceholders = addInlinePlaceholders(block.trim());
      const escaped = escapeHtml(withPlaceholders);
      if (!escaped) {
        return '';
      }
      const withBreaks = escaped.replace(/\n/g, '<br>');
      const withItalics = withBreaks.replace(/\[\[ITALIC::(.*?)\]\]/g, '<em>$1</em>');
      const withSiteLink = linkifySignatureInstagram(linkifySignatureDomain(withItalics));
      return `<p style="margin:0 0 12px 0">${withSiteLink}</p>`;
    })
    .filter(Boolean)
    .join('\n');

  return `<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
  <title>Message from Alexander Almgren</title>
  <style type="text/css">
    body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    body { margin: 0; padding: 0; width: 100%; }
  </style>
</head>
<body style="margin:0; padding:0; background-color:#ffffff; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:1.5; color:#222222;">
  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#ffffff;">
    <tr>
      <td style="padding:20px;">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="max-width:600px;">
          <tr>
            <td style="font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:1.5; color:#222222;">
${body}
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
};
